import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const hasToken = !!localStorage.getItem("sn_token");
  if (!user && !hasToken) return <Navigate to="/login" replace />;
  return children;
}
